export default __webpack_public_path__ + "static/media/05_antivibracni-rukavice.16149cc0.jpg";